const { regionalSelector } = window.liquid;

const {
  storeRegion,
  aunz_url,
  usca_url,
  auWhitelistedCountries,
  usWhitelistedCountries,
} = regionalSelector;

const DEFAULT_STORE_REGIONS = 'AU';

const STORE_WHITELISTED_REGIONS = {
  AU: auWhitelistedCountries,
  US: usWhitelistedCountries,
};

/**
 * Robot checker
 * Returns true if the visitor is a robot.
 * @returns {boolean}
 **/
function robotChecker() {
  var robotList =
    '(googlebot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|googlebot)';

  var regex = new RegExp(robotList, 'i');
  var userAgent = navigator.userAgent;
  if (regex.test(userAgent)) {
    return true;
  } else {
    return false;
  }
}

/**
 * Redirect to the appropriate store.
 * @param {string} country The ISO Code of the country that the visitor is from
 **/
function redirect(country) {
  const isoCountryCode = country.iso_code;

  if (STORE_WHITELISTED_REGIONS[storeRegion].indexOf(isoCountryCode) > -1) {
    return;
  }

  setRegionalName(country.names.en);
  if (STORE_WHITELISTED_REGIONS['US'].indexOf(isoCountryCode) > -1) {
    setRedirctUrl(usca_url);
    showRegionalSelector();
    return;
  }

  if (DEFAULT_STORE_REGIONS !== storeRegion) {
    setRedirctUrl(aunz_url);
    showRegionalSelector();
    return;
  }
  return;
}

/**
 * Processes the maxmind geoip2 response
 * @param {object} response
 **/
function onSuccess(response) {
  const country = response.country;
  redirect(country);
}

// Do nothing on failure
function onFailure(response) {
  console.warn(response);
  return;
}
/**
 *
 **/
function getURLParam(param) {
  var url_string = window.location.href;
  var url = new URL(url_string);
  return url.searchParams.get(param);
}

/**
 * Does a number of checks to see if we should redirect the customer or not.
 **/
function redirectionCheck() {
  if (typeof window.top.ThemeEditor !== 'undefined') {
    return;
  }
  if (!robotChecker()) {
    geoip2.country(onSuccess, onFailure);
  }
}

function setRegionalName(visitingCountryName) {
  const countryName = visitingCountryName ? visitingCountryName : '';

  $('[data-set-regional-name]').each(function() {
    const title = $(this)
      .text()
      .replace('$$$', countryName);

    $(this).text(title);
  });
}

function setRedirctUrl(url) {
  console.log('setRedirctUrl', url);
  $('.regional-selecter__button').attr('data-regional-redirct-to', url);
}

function showRegionalSelector() {
  var cookiesRegionalPopup = Cookies.get('regional-popup');

  if ($('body').hasClass('page-cart')) {
    showRegionalPopup();
  } else if (cookiesRegionalPopup != 'dismiss') {
    showRegionalPopup();
    return;
  }

  showRegionalAnnouncementBar();
  return;
}

function showRegionalAnnouncementBar() {
  $('.regional-announcement-bar').show();
}

function showRegionalPopup() {
  $('#regional-popup').show();
  $('body').addClass('regional-popup-showing');
}

function closeRegionalPopup() {
  $('#regional-popup').hide();
  $('body').removeClass('regional-popup-showing');
  Cookies.set('regional-popup', 'dismiss');
}

$(document).on('click', '[data-regional-announcement-close]', function() {
  $('.regional-announcement-bar').hide();
});

$(document).on('click', '[data-regional-popup-close]', function(event) {
  event.preventDefault();
  closeRegionalPopup();
});

$(document).on('click', '[data-regional-redirct-to]', function() {
  const domain = $(this).attr('data-regional-redirct-to');
  const refUrl = `${domain}?ref=${storeRegion}_store_redirect`;
  window.location = refUrl;
});

redirectionCheck();
